import { Button, styled } from "@mui/material";

export const FooterButton = styled(Button)({
    display: "flex",
    background: "none",
    border: "none",
    margin: "auto",
    textDecoration: "none",
    color: "var(--community-color-primary-text)",
    fontWeight: "500",
    fontSize: "16px",
    textTransform: "initial",
    padding: "6px 16px",
    "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
    svg: {
        width: "24px",
        height: "24px",
        marginRight: "10px",
    },
});
